import axios from "axios";
import Moment from "moment";
import { useEffect, useState } from "react";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import SelectComponent from "../../components/Common/Select";
import {
  getWebBookingStatus,
  webBookingProfileStatus,
} from "../../components/Constants";
import ListPageLayout from "../../components/Layout";
import AssignedTo from "../../components/Modal/AssignedTo";
import LeadStatus from "../../components/Modal/LeadStatus";
import SucessModal from "../../components/Modal/SucessModal";
import { formatDateTime, updatedBookingStatus } from "../../components/Utils";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";
import "./webBooking.scss";

const WebBookingHomeHealthCare = () => {
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }))
  );
  const [loader, setLoader] = useState(true);

  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}web-bookings/list`,
      initialParams: { sort, searchText: search },
    });

  const handleSortClick = useSortHandler(setSort, setSortName);
  const handlePageChange = usePageChange(pagination, setPagination);

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const updateStatus = async (url, id, value, updateFn) => {
    setLoader(true)
    await axios.patch(
      `${process.env.REACT_APP_API_URL}${url}/update/${id}`,
      updateFn(value)
    );
    fetchData();
  };

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    fetchData();
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: "name",
      fixed: "left",
    },
    {
      title: "Mobile No",
      dataIndex: "mobile",
      fixed: "left",
    },
    {
      title: "Email id",
      dataIndex: "email",
      fixed: "left",
    },
    {
      title: "City",
      dataIndex: "city",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
    {
      title: "Pincode",
      dataIndex: "pincode",
    },
    {
      title: "Service Category",
      dataIndex: "service_category",
    },
    {
      title: "Health Conditions",
      dataIndex: "health_conditions",
      render: (conditions = []) => (
        <div>
          {conditions.map((cond, idx) => (
            <div key={idx}>{cond}</div>
          ))}
        </div>
      ),
    },
    {
      title: "Received At",
      dataIndex: "createdAt",
      render: (val) => Moment(val).format("MMMM DD, YYYY LT"),
    },
    {
      title: "Booking Requested Date & Time",
      render: (_, record) => formatDateTime(record?.date, record?.time),
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      render: (val) => val || "-",
    },
    {
      title: "Lead Status",
      dataIndex: "lead_status",
      render: (val) => val || "-",
    },
    {
      title: "Action",
      render: (_, record) => (
        <SelectComponent
          props={{
            Array: webBookingProfileStatus,
            value: getWebBookingStatus(record),
            style: { color: "#CB1B5B", width: "200px" },
            onChange: (value) =>
              updateStatus(
                "web-bookings",
                record._id,
                value,
                updatedBookingStatus
              ),
          }}
        />
      ),
    },
  ];
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <ListPageLayout
      breadcrumbs={<></>}
      addButton={<></>}
      titles={<></>}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination({
              ...pagination,
              limit: val,
              skip: 0,
              currentPage: 1,
            })
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource: records.map((el) => ({ ...el, key: el._id })),
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
      loader={loader}
    >
      {assignModal.status && (
        <AssignedTo
          id={assignModal.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
        />
      )}
      {success && (
        <SucessModal name="BD" post="Assigned" onClick={successModalClose} />
      )}
      {leadStatusModal.status && (
        <LeadStatus
          id={leadStatusModal.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
        />
      )}
      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={successModalClose}
        />
      )}
    </ListPageLayout>
  );
};

export default WebBookingHomeHealthCare;
